/** "Go live is today" / "12d to go live" / "Live 3d". */
export function goLiveLabel(days: number): string {
  if (days === 0) return "Go live is today";
  if (days < 0) return `Live ${Math.abs(days)}d`;
  return `${days}d to go live`;
}

/** "Thu, Oct 9". */
export function goLiveDateLabel(goLiveDate: string): string {
  return new Date(`${goLiveDate}T00:00:00`).toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
}
